import { render } from "./WriterBase.vue?vue&type=template&id=e7dae24a&scoped=true"
import script from "./WriterBase.vue?vue&type=script&lang=js"
export * from "./WriterBase.vue?vue&type=script&lang=js"

import "./WriterBase.vue?vue&type=style&index=0&id=e7dae24a&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7dae24a"]])

export default __exports__